/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types';

import React from 'react';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';
import PopOver from '../../../../shared/components/IconDropdownMenu/PopOver';

import './Header.scss';
import Button from '../../../components/Button';
import SubscriptionButton from '../../../components/SubscriptionButton';
import Localized from '../../../../shared/components/Localized';
import { UtilityIcon } from '../../../components/SVGIcon';
import { Link } from 'react-router-dom';
import config from '../../../../config';

import styles from '../../../styles';

// need to be div instead of button, else the onclick won't execute in Firefox
const Wrapper = styled.div`
  line-height: 1.875rem;
  text-align: center;
  vertical-align: middle;
  background-color: #fff;
  border: 1px solid ${styles.colors.geyser};
  border-radius: 0.25rem;
  vertical-align: top;
  align-self: center;
  display: inline-block;
  padding: 0 0.75rem;
  :hover {
    background-color: #f4f6f9;
    cursor: pointer;
  }
`;
const ButtonWrapper = styled.div`
  ${Button} + ${Button} {
    margin-left: 0.75rem;
  }
`;
const StyledButton = styled(Button)`
  margin-right: 0.45rem;
  height: 32px;
`;

export default class DetailsHeader extends React.Component {
  constructor(props) {
    super(props);
  }
  static propTypes = {
    instance: PropTypes.object,
    instanceAlias: PropTypes.string,
    locale: PropTypes.string,
  };
  render() {
    const { instanceKey, instanceAlias, locale } = this.props;
    const emailIcon = (
      <svg width="16px" height="16px" fill="#54698d">
        <use xlinkHref={'/assets/icons/utility-sprite/svg/symbols.svg#email'}></use>
      </svg>
    );
    const downIcon = <UtilityIcon size="1rem" icon="down" />;
    const menuOptions = [
      {
        icon: <UtilityIcon icon="notification"></UtilityIcon>,
        label: <Localized modelName="subscribeModal" modelAttribute="label" modelKey="Manage my subscription" />,
        onClick: () => {
          let url = window.location.pathname;
          const delimiter = instanceAlias || instanceKey;
          url = url.slice(0, url.indexOf(delimiter) + delimiter.length);
          window.location.pathname = '/subscriptions';
        },
        title: 'Notifications',
      },
    ];

    const dropdownProps = {
      offsetRight: '-24px',
      skipSeparator: true,
      menuOptions,
    };
    const elem = (
      <span>
        <Localized modelName="button" modelAttribute="label" modelKey="subscribe" /> {downIcon}
      </span>
    );
    return (
      <ButtonWrapper>
        <MediaQuery minWidth={768}>
          <SubscriptionButton isSubscribed={this.props.isSubscribed} instanceKey={instanceKey} />
        </MediaQuery>
        <MediaQuery maxWidth={767}>
          <Wrapper className="slds-button slds-button_neutral">
            <PopOver elem={elem} dropdownProps={dropdownProps} />
          </Wrapper>
        </MediaQuery>
      </ButtonWrapper>
    );
  }
}
